export default "__VITE_PUBLIC_ASSET__76acd12c__"